import React from "react";
import { useParams } from "react-router-dom";

const IGScreen = ({ location = "Here", children }) => {
  const { locationslug } = useParams();
  return (
    <div
      style={{ maxWidth: "400px", marginRight: "auto", marginLeft: "auto" }}
      className="h-100"
    >
      <div className="d-flex w-100 h-100 justify-content-center align-items-center">
        <div className="d-flex flex-row justify-content-center h-100 {% if creator_css_classNamees %} w-auto mx-auto lomavisCreatorFeedPreviewContainer mh-1200px {% else %} w-100 mx-auto {% endif %}">
          <div
            className="mx-auto my-auto position-relative bg-black user-select-none mw-100 mh-100 h-100"
            style={{
              padding: "10px",
              aspectRatio: "15/32",
              height: "100%",
              boxShadow: "0 0 20px #e2e2e2",
              borderRadius: "30px",
            }}
          >
            <div
              className=" bg-black mx-auto position-absolute start-0 end-0"
              style={{
                width: "40%",
                height: "4%",
                maxWidth: "130px",
                borderRadius: "0 0 10px 10px",
                maxHeight: "22px",
              }}
            >
              <span
                className="bg-dark d-block mx-auto rounded-pill"
                style={{
                  width: "50%",
                  height: "3px",
                  marginTop: "0.3em",
                  maxWidth: "60px",
                }}
              ></span>
            </div>
            <div
              className="h-100 w-100"
              style={{ borderRadius: "20px", overflow: "hidden" }}
            >
              <div
                className="w-100 bg-white"
                style={{ height: "6%", maxHeight: "32px" }}
              >
                <svg
                  className="w-100 h-100"
                  viewBox="0 0 414 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M347 19.6998C349.612 19.7 352.124 20.7094 354.017 22.5194C354.159 22.6592 354.387 22.6574 354.527 22.5155L355.89 21.1324C355.961 21.0604 356.001 20.9629 356 20.8614C355.999 20.7599 355.959 20.6629 355.887 20.5917C350.919 15.8028 343.081 15.8028 338.113 20.5917C338.042 20.6628 338.001 20.7599 338 20.8613C337.999 20.9628 338.039 21.0603 338.11 21.1324L339.473 22.5155C339.613 22.6576 339.841 22.6594 339.984 22.5194C341.877 20.7092 344.389 19.6998 347 19.6998ZM347 24.1997C348.435 24.1996 349.819 24.7361 350.883 25.7049C351.027 25.8424 351.253 25.8395 351.394 25.6982L352.754 24.3151C352.826 24.2426 352.866 24.1441 352.865 24.0419C352.864 23.9396 352.822 23.842 352.749 23.7709C349.51 20.7403 344.494 20.7403 341.255 23.7709C341.182 23.842 341.14 23.9396 341.139 24.0419C341.138 24.1442 341.178 24.2427 341.25 24.3151L342.61 25.6982C342.75 25.8395 342.977 25.8424 343.121 25.7049C344.184 24.7368 345.567 24.2003 347 24.1997ZM349.616 27.5006C349.689 27.4288 349.729 27.3299 349.727 27.2273C349.725 27.1248 349.68 27.0276 349.605 26.9588C348.101 25.6798 345.9 25.6798 344.396 26.9588C344.32 27.0276 344.276 27.1247 344.274 27.2272C344.272 27.3298 344.312 27.4287 344.385 27.5006L346.739 29.8902C346.808 29.9605 346.902 30 347 30C347.099 30 347.193 29.9605 347.262 29.8902L349.616 27.5006Z"
                    fill="black"
                  />
                  <path
                    d="M362.923 20.2051C362.923 19.4971 363.497 18.9231 364.205 18.9231H381.833C382.541 18.9231 383.115 19.4971 383.115 20.2051V26.2949C383.115 27.0029 382.541 27.5769 381.833 27.5769H364.205C363.497 27.5769 362.923 27.0029 362.923 26.2949V20.2051Z"
                    fill="black"
                  />
                  <path
                    opacity="0.4"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M364.205 17.9615H381.833C383.072 17.9615 384.077 18.966 384.077 20.2051V26.2949C384.077 27.534 383.072 28.5385 381.833 28.5385H364.205C362.966 28.5385 361.962 27.534 361.962 26.2949V20.2051C361.962 18.966 362.966 17.9615 364.205 17.9615ZM361 20.2051C361 18.435 362.435 17 364.205 17H381.833C383.603 17 385.038 18.435 385.038 20.2051V26.2949C385.038 28.065 383.603 29.5 381.833 29.5H364.205C362.435 29.5 361 28.065 361 26.2949V20.2051ZM387.603 23.25C387.603 24.2351 386.919 25.0605 386 25.2776V21.2224C386.919 21.4395 387.603 22.2649 387.603 23.25Z"
                    fill="black"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M329.85 18C329.298 18 328.85 18.4477 328.85 19V28C328.85 28.5523 329.298 29 329.85 29H331.15C331.702 29 332.15 28.5523 332.15 28V19C332.15 18.4477 331.702 18 331.15 18H329.85ZM323.9 21.1999C323.9 20.6476 324.348 20.1999 324.9 20.1999H326.2C326.752 20.1999 327.2 20.6476 327.2 21.1999V27.9999C327.2 28.5522 326.752 28.9999 326.2 28.9999H324.9C324.348 28.9999 323.9 28.5522 323.9 27.9999V21.1999ZM319.95 22.4C319.398 22.4 318.95 22.8478 318.95 23.4V28C318.95 28.5523 319.398 29 319.95 29H321.25C321.802 29 322.25 28.5523 322.25 28V23.4C322.25 22.8478 321.802 22.4 321.25 22.4H319.95ZM315.1 29C314.492 29 314 28.5075 314 27.9V25.15C314 24.5425 314.492 24.05 315.1 24.05H316.2C316.808 24.05 317.3 24.5425 317.3 25.15V27.9C317.3 28.5075 316.808 29 316.2 29H315.1Z"
                    fill="black"
                  />
                  <path
                    d="M43.3499 30H45.5735V17.3174H43.3323L40.0188 19.6465V21.7295L43.2971 19.4795H43.3499V30ZM52.86 17.0977C50.1266 17.0977 48.1139 18.9346 48.1139 21.4922V21.5098C48.1139 23.8916 49.8366 25.6494 52.2799 25.6494C53.9938 25.6494 55.2594 24.7705 55.7604 23.6104H55.8131C55.8131 23.751 55.8043 23.8828 55.7955 24.0146C55.7077 26.4141 54.8551 28.3652 52.8161 28.3652C51.6823 28.3652 50.9088 27.8027 50.5661 26.9326L50.5397 26.8535H48.2897L48.3073 26.9502C48.7028 28.8662 50.4606 30.2197 52.8073 30.2197C56.0416 30.2197 57.984 27.7148 57.984 23.5225V23.5049C57.984 19.0576 55.6549 17.0977 52.86 17.0977ZM52.86 23.9004C51.4186 23.9004 50.3463 22.8721 50.3463 21.4307V21.4131C50.3463 20.042 51.4801 18.9521 52.8864 18.9521C54.3102 18.9521 55.4176 20.0508 55.4176 21.457V21.4658C55.4176 22.8809 54.3102 23.9004 52.86 23.9004ZM60.4541 21.7031C61.166 21.7031 61.7197 21.1406 61.7197 20.4287C61.7197 19.7168 61.166 19.1631 60.4541 19.1631C59.7422 19.1631 59.1797 19.7168 59.1797 20.4287C59.1797 21.1406 59.7422 21.7031 60.4541 21.7031ZM60.4541 28.1543C61.166 28.1543 61.7197 27.5918 61.7197 26.8799C61.7197 26.168 61.166 25.6143 60.4541 25.6143C59.7422 25.6143 59.1797 26.168 59.1797 26.8799C59.1797 27.5918 59.7422 28.1543 60.4541 28.1543ZM67.9164 30.2197C71.0189 30.2197 72.8998 27.6973 72.8998 23.6631V23.6455C72.8998 19.6113 71.0189 17.0977 67.9164 17.0977C64.805 17.0977 62.933 19.6113 62.933 23.6455V23.6631C62.933 27.6973 64.805 30.2197 67.9164 30.2197ZM67.9164 28.3652C66.2025 28.3652 65.2181 26.5898 65.2181 23.6631V23.6455C65.2181 20.7188 66.2025 18.9609 67.9164 18.9609C69.6214 18.9609 70.6146 20.7188 70.6146 23.6455V23.6631C70.6146 26.5898 69.6214 28.3652 67.9164 28.3652ZM74.113 30H83.0251V28.1455H77.1101V28.0488L79.905 25.3945C82.1374 23.25 82.8318 22.2393 82.8318 20.7451V20.7275C82.8318 18.6357 81.0564 17.0977 78.5163 17.0977C75.9411 17.0977 73.99 18.7588 73.99 21.0791V21.1406H76.1169V21.0791C76.1433 19.8574 77.1277 18.917 78.5339 18.917C79.7556 18.917 80.6081 19.7256 80.6169 20.8594V20.877C80.6169 21.8174 80.2566 22.459 78.5954 24.085L74.113 28.4531V30Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div
                className="w-100 bg-white d-flex d-flex-row"
                style={{ height: "6%", maxHeight: "32px" }}
              >
                <div className="ps-2">
                  <svg
                    width="100%"
                    height="60%"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.7186 3.5L8.16666 14.0519L18.7186 24.6039"
                      stroke="black"
                      strokeWidth="2"
                      strokeMiterlimit="10"
                    />
                  </svg>
                </div>
                <div className="flex-fill w-75">
                  <p
                    className="mx-auto text-center fw-bold m-0 p-0 ps-4 pt-1 text-dark "
                    style={{ fontSize: "x-small" }}
                  >
                    {"Instagram"}
                  </p>
                </div>
                <div className="pe-2">
                  <svg
                    width="100%"
                    height="60%"
                    viewBox="0 0 28 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_4_140)">
                      <path
                        d="M14.2123 3.80589C19.2582 3.71387 23.2995 7.7782 23.2995 12.8088V16.7044C23.2995 18.4835 23.821 20.2243 24.8026 21.7043L25.278 22.4252C25.4161 22.6322 25.2627 22.9159 25.0173 22.9159H3.41502C3.16196 22.9159 3.01625 22.6399 3.15429 22.4252L3.62974 21.7043C4.61131 20.2166 5.13277 18.4758 5.13277 16.7044V12.8088C5.1251 7.78587 9.16642 3.71387 14.2123 3.80589Z"
                        stroke="black"
                        strokeWidth="1.8"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                      <path
                        d="M11.2763 24.8712C11.1229 24.8712 11.0079 25.0245 11.0616 25.1703C11.5523 26.4356 12.7716 27.3328 14.2133 27.3328C15.655 27.3328 16.8666 26.4356 17.3651 25.1703C17.4188 25.0245 17.3037 24.8712 17.1504 24.8712H11.2763V24.8712Z"
                        fill="black"
                      />
                      <path
                        d="M16.3292 3.82883C16.4365 3.82883 16.5209 3.71381 16.4825 3.61411C16.1298 2.70156 15.2479 2.04973 14.2126 2.04973C13.1774 2.04973 12.2955 2.70156 11.9428 3.61411C11.9044 3.71381 11.9888 3.82883 12.0961 3.82883C13.8599 3.39173 15.2709 3.39173 16.3292 3.82883V3.82883Z"
                        fill="black"
                        stroke="black"
                        strokeWidth="0.657304"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_140">
                        <rect
                          width="23.7571"
                          height="25.6667"
                          fill="white"
                          transform="translate(2.33334 1.66666)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="pe-2">
                  <svg
                    width="100%"
                    height="60%"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.46518 16.4304C7.45848 16.4304 8.2637 15.6251 8.2637 14.6319C8.2637 13.6386 7.45848 12.8333 6.46518 12.8333C5.47189 12.8333 4.66667 13.6386 4.66667 14.6319C4.66667 15.6251 5.47189 16.4304 6.46518 16.4304Z"
                      fill="black"
                    />
                    <path
                      d="M13.9965 16.4304C14.9898 16.4304 15.795 15.6251 15.795 14.6319C15.795 13.6386 14.9898 12.8333 13.9965 12.8333C13.0032 12.8333 12.198 13.6386 12.198 14.6319C12.198 15.6251 13.0032 16.4304 13.9965 16.4304Z"
                      fill="black"
                    />
                    <path
                      d="M21.5348 16.4304C22.5281 16.4304 23.3333 15.6251 23.3333 14.6319C23.3333 13.6386 22.5281 12.8333 21.5348 12.8333C20.5415 12.8333 19.7363 13.6386 19.7363 14.6319C19.7363 15.6251 20.5415 16.4304 21.5348 16.4304Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
              <div
                className="w-100 bg-white d-flex d-flex-row border-bottom pt-1 "
                style={{ height: "7%", maxHeight: "40px" }}
              >
                <div className="flex-fill border-bottom border-dark pb-2">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4 5C4 4.44772 4.44772 4 5 4H23C23.5523 4 24 4.44772 24 5V23C24 23.5523 23.5523 24 23 24H5C4.44772 24 4 23.5523 4 23V5ZM6 9.99406V6H10.0094V9.99406H6ZM6 11.9941V16.0001H10.0094V11.9941H6ZM6 18.0001V22H10.0094V18.0001H6ZM12.0094 22H16.0153V18.0001H12.0094V22ZM18.0153 22H22V18.0001H18.0153V22ZM22 16.0001V11.9941H18.0153V16.0001H22ZM22 9.99406V6H18.0153V9.99406H22ZM16.0153 6H12.0094V9.99406H16.0153V6ZM12.0094 16.0001V11.9941H16.0153V16.0001H12.0094Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="flex-fill pb-2">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.0753 12.8928C12.418 12.5337 11.6137 12.998 11.5961 13.7468L11.4743 18.9189C11.4559 19.699 12.2982 20.1986 12.974 19.8085L17.6359 17.117C18.3116 16.7268 18.3001 15.7475 17.6153 15.3734L13.0753 12.8928Z"
                      fill="#8E8E8E"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10 3C6.13401 3 3 6.13401 3 10V18C3 21.866 6.13401 25 10 25H18C21.866 25 25 21.866 25 18V10C25 6.13401 21.866 3 18 3H10ZM18 5H17.2392L17.8321 5.98816L19.0704 8.11112H22.6309C21.8857 6.28608 20.0931 5 18 5ZM10.8488 5H14.9069L16.1076 7.00124L16.755 8.11112H12.6829L11.5464 6.16277L10.8488 5ZM5.36909 8.11112C5.94518 6.7002 7.14733 5.6114 8.63033 5.18992L9.8219 7.17588L10.3675 8.11112H5.36909ZM5 18V10.1111H11.5341L11.5449 10.1296L11.5765 10.1111H23V18C23 20.7614 20.7614 23 18 23H10C7.23858 23 5 20.7614 5 18Z"
                      fill="#8E8E8E"
                    />
                  </svg>
                </div>
                <div className="flex-fill pb-2">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14 17.7266C16.4853 17.7266 18.5 15.7118 18.5 13.2266C18.5 10.7413 16.4853 8.72656 14 8.72656C11.5147 8.72656 9.5 10.7413 9.5 13.2266C9.5 15.7118 11.5147 17.7266 14 17.7266ZM14 15.7266C15.3807 15.7266 16.5 14.6073 16.5 13.2266C16.5 11.8459 15.3807 10.7266 14 10.7266C12.6193 10.7266 11.5 11.8459 11.5 13.2266C11.5 14.6073 12.6193 15.7266 14 15.7266Z"
                      fill="#8E8E8E"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23 25.3047C24.1046 25.3047 25 24.4093 25 23.3047V7.30469C25 6.20012 24.1046 5.30469 23 5.30469H16.9949C16.719 5.30469 16.4553 5.19068 16.2663 4.98965L14.8201 3.45127C14.4319 3.03836 13.7785 3.03024 13.3801 3.4334L11.8249 5.00752C11.637 5.19767 11.3808 5.30469 11.1135 5.30469H5C3.89543 5.30469 3 6.20012 3 7.30469V23.3047C3 24.4093 3.89543 25.3047 5 25.3047H23ZM23 23.3047V7.30469H16.9949C16.1671 7.30469 15.3761 6.96266 14.8092 6.35956L14.0736 5.57715L13.2476 6.41319C12.684 6.98364 11.9154 7.30469 11.1135 7.30469L5 7.30469L5 23.3047L6.72489 23.3047C6.85515 20.6594 9.04116 18.5547 11.7188 18.5547H16.625C19.3026 18.5547 21.4886 20.6594 21.6189 23.3047L23 23.3047ZM19.6147 23.3047C19.4877 21.7648 18.1977 20.5547 16.625 20.5547H11.7188C10.1461 20.5547 8.85606 21.7648 8.72902 23.3047H19.6147Z"
                      fill="#8E8E8E"
                    />
                  </svg>
                </div>
              </div>

              <div
                className="w-100 h-100 bg-white pt-1"
                style={{ overflowY: "auto", paddingBottom: "1em" }}
                id="instagramMockupPostsContainerScrollableWrapper"
              >
                {children}
                {/* <div
                  className="align-self-xl-stretch mb-15"
                  id="instagramMockupPostsContainer"
                >
                  <div
                    className="position-absolute top-50 start-50 translate-middle"
                    id="instagramMockupLoadingSpinner"
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
                <div className="position-absolute top-50 start-50 translate-middle instagramMockupNoPostsAvailable">
                  <div className="w-80 text-dark text-center mx-auto ">
                    "No Instagram posts available for feed preview"
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className=""></div>
        </div>
      </div>
    </div>
  );
};

export default IGScreen;
